package com.vizio.redwolf.auth.model

data class SocialLoginRequestInfo(
    val email: String?,
    val facebookToken: String?,
    val googleToken: String?,
    val appleToken: String?,
    val reCaptchaToken: String? = null
)